import type { JSX } from 'react';

/**
 * AssistedEnrollmentPage — stub. Requires staff:wa role.
 * Full implementation coming in a future story (Story 3.2).
 */
export function AssistedEnrollmentPage(): JSX.Element {
  return (
    <div className="p-8">
      <h1 className="text-2xl font-semibold text-gray-900">Assisted Enrollment</h1>
      <p className="mt-2 text-gray-500">Coming in Story 3.2.</p>
    </div>
  );
}
